import { record as e, EventType as n, pack as t } from "zipy-rrweb";
import { v4 as r } from "uuid";
var o, i, s, a, u;
!function (e) {
  e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.ReplayerEvent = 11] = "ReplayerEvent", e[e.ConsoleInfo = 50] = "ConsoleInfo", e[e.ConsoleError = 51] = "ConsoleError", e[e.ConsoleWarning = 52] = "ConsoleWarning", e[e.ConsoleDebug = 53] = "ConsoleDebug", e[e.Error = 70] = "Error", e[e.RangeError = 71] = "RangeError", e[e.ReferenceError = 72] = "ReferenceError", e[e.TypeError = 73] = "TypeError", e[e.SyntaxError = 74] = "SyntaxError", e[e.URIError = 75] = "URIError", e[e.EvalError = 76] = "EvalError", e[e.UnhandledRejection = 77] = "UnhandledRejection", e[e.BROWSERDATA = 100] = "BROWSERDATA", e[e.NAVIGATION = 101] = "NAVIGATION", e[e.Online = 102] = "Online", e[e.Offline = 103] = "Offline", e[e.XHR = 104] = "XHR", e[e.WSOPEN = 105] = "WSOPEN", e[e.WSCLOSE = 106] = "WSCLOSE", e[e.WSMESSAGE = 107] = "WSMESSAGE", e[e.WSERROR = 108] = "WSERROR", e[e.Fonts = 109] = "Fonts", e[e.Link = 110] = "Link", e[e.Css = 111] = "Css", e[e.Image = 112] = "Image", e[e.Js = 113] = "Js", e[e.Media = 114] = "Media", e[e.ZipyLogMessage = 115] = "ZipyLogMessage", e[e.ZipyLogException = 116] = "ZipyLogException", e[e.ZipyLogFrontendError = 117] = "ZipyLogFrontendError", e[e.ZipyLogNetworkError = 118] = "ZipyLogNetworkError";
}(o || (o = {})), function (e) {
  e[e.MESSAGESEND = 0] = "MESSAGESEND", e[e.MESSAGERECEIVED = 1] = "MESSAGERECEIVED", e[e.SOCKETCLOSE = 2] = "SOCKETCLOSE", e[e.SOCKETERROR = 3] = "SOCKETERROR", e[e.SOCKETOPEN = 4] = "SOCKETOPEN";
}(i || (i = {})), function (e) {
  e[e.POSTENDUSERINFOANDGETUSERCONFIG = 0] = "POSTENDUSERINFOANDGETUSERCONFIG", e[e.POSTENDUSERINFO = 1] = "POSTENDUSERINFO", e[e.GETUSERCONFIG = 2] = "GETUSERCONFIG";
}(s || (s = {})), function (e) {
  e[e.ANONYMS = 0] = "ANONYMS", e[e.IDENTIFIED = 1] = "IDENTIFIED";
}(a || (a = {})), function (e) {
  e[e.NORECORDING = 0] = "NORECORDING", e[e.RECORDINGPENDING = 1] = "RECORDINGPENDING", e[e.RECORDINGSUCCESSFUL = 2] = "RECORDINGSUCCESSFUL";
}(u || (u = {}));
var c = {
    streamMgrUrl: "https://services.zipy.ai/sdk-session-manager/v2/enduser-info",
    registerSessionUrl: "https://services.zipy.ai/sdk-session-manager/v1/register-sdk-session",
    sdkVersion: "Beta0.3.22",
    errorUrl: "divolte.collector",
    streamMgrRetryCount: 5,
    zipyDeploymentEnviornment: "Production",
    sdkLoopTime: 1e3,
    ignoreEmptyErros: !0,
    ignoreLargeResponse: !0,
    debugLogs: !1,
    sessionLinkUrl: "https://app.zipy.ai"
  },
  d = !1;
function l(e) {
  d && console.info("zipy", e);
}
function p(e) {
  d && console.debug("zipy", e);
}
function f(e) {
  d && console.log("zipy", e);
}
function g(e) {
  d && console.error("zipy", e);
}
function v() {
  return v = Object.assign ? Object.assign.bind() : function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, v.apply(this, arguments);
}
function y(e, n) {
  return y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, n) {
    return e.__proto__ = n, e;
  }, y(e, n);
}
function w() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function m(e, n, t) {
  return m = w() ? Reflect.construct.bind() : function (e, n, t) {
    var r = [null];
    r.push.apply(r, n);
    var o = new (Function.bind.apply(e, r))();
    return t && y(o, t.prototype), o;
  }, m.apply(null, arguments);
}
function h(e, n) {
  (null == n || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
  return r;
}
function E(e, n) {
  var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = function (e, n) {
    if (e) {
      if ("string" == typeof e) return h(e, n);
      var t = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? h(e, n) : void 0;
    }
  }(e)) || n && e && "number" == typeof e.length) {
    t && (e = t);
    var r = 0;
    return function () {
      return r >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[r++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function S() {
  return Date.now();
}
function z(e, n, t) {
  var r = {
    capture: !0,
    passive: !0
  };
  return t.addEventListener(e, n, r), function () {
    return t.removeEventListener(e, n, r);
  };
}
function I() {
  var e = Math.floor(Date.now() / 1e3);
  return r() + "-" + e;
}
function k(e) {
  var n = {
    externalId: "enduser_external_id",
    firstName: "eu_first_name",
    lastName: "eu_last_name",
    email: "eu_email",
    age: "eu_age",
    customerName: "eu_customer_name",
    avatar: "eu_avatar",
    phone: "eu_phone"
  };
  return e in n ? n[e] : e;
}
var C = {
  domCapture: !0,
  consoleCapture: !0,
  networkCapture: !0,
  stackTraceCapture: !0,
  webSocketsCapture: !1,
  ipCapture: !0,
  inputMasking: !0,
  textMasking: !0,
  paid: !1,
  apiKey: "",
  streamUrl: "https://collector.zipy.ai",
  maxBufferSize: 5e6,
  compression: !0,
  compressionType: "gzip",
  timeFrequency: 1e3,
  encodingType: "",
  sessionTimeout: 18e5,
  failureRetryCount: 5,
  bufferSizeFrequency: 1048576,
  ignoreUrl: ["google.com", "zipy.ai", "mixpanel", "extreme-ip-lookup.com", "hotjar", "smartlook.com", "newrelic.com", "bugsnag", "fullstory", "sentry.io", "google-analytics.com", "bam.nr-data.net", "wistia.com", "amplitude.com", "segment.io", "pendo.io", "raygun", "smartlook.cloud", "segment.com", "visualstudio.com", "stats.g.doubleclick.net", "pagead2.googlesyndication.com", "r.lr-in.com"],
  ignoreError: ["rrweb", "zipy", "Script error", "pagead2.googlesyndication.com", "adsbygoogle"],
  ignoreConsole: ["{}"],
  isIgnoreUrlError: ["google.com", "zipy.ai", "mixpanel", "extreme-ip-lookup.com", "hotjar", "smartlook.com", "newrelic.com", "bugsnag", "fullstory", "sentry.io", "google-analytics.com", "bam.nr-data.net", "wistia.com", "amplitude.com", "segment.io", "pendo.io", "raygun", "smartlook.cloud", "segment.com", "visualstudio.com", "stats.g.doubleclick.net", "pagead2.googlesyndication.com", "r.lr-in.com"],
  isIgnoreConsoleError: ["{}"],
  ip: "",
  pack: !1,
  blockClasses: "zipy-block",
  xhrReqPayloadCapture: !1,
  xhrRespPayloadCapture: !1,
  canvasCapture: !1,
  scrubbingKey: ["password", "secret", "passwd", "api_key", "apikey", "access_token", "auth", "credentials", "mysql_pwd", "stripetoken", "cardnumber"],
  requestCapSize: 1e6,
  responseCapSize: 1e6,
  sizeExceededMessage: {
    message: "size too large",
    source: "zipy"
  },
  eventCountCapInSingleChunk: 0,
  captureCustomZipyLogMessage: !1,
  captureCustomZipyLogError: !1,
  captureCustomZipyLogException: !1
};
function N(e) {
  return v({}, e, {
    timestamp: S()
  });
}
function R() {
  try {
    return window.sdkConfig ? window.sdkConfig : C;
  } catch (e) {
    return g("Failed to parse end user Info data"), C;
  }
}
function b(e) {
  try {
    var n = R();
    return n && n.hasOwnProperty && n.hasOwnProperty(e) ? n[e] : null;
  } catch (e) {
    return g(e.message ? JSON.stringify(e) : e), null;
  }
}
var O = function O(e, n, t) {
    return e && e.constructor === String && t.indexOf(e) === n;
  },
  D = function D(e) {
    return e && e.constructor === String && e.trim();
  };
function x(e) {
  var n = U();
  return n.length > 0 ? (n.forEach(function (n) {
    return delete e[n];
  }), e) : e;
}
function T(e) {
  var n = U();
  return n.length > 0 && n.indexOf(e) > -1;
}
function U() {
  var e = b("headersToSanitize");
  return e && e.length ? e.split(",") : [];
}
function _(e) {
  if (!Array.isArray(e)) return [];
  for (var n, t = [], r = E(e); !(n = r()).done;) {
    var o = n.value;
    try {
      o && "object" == typeof o && JSON.stringify(o) ? t.push("Error" === o.constructor.name ? {
        message: o.message,
        name: o.name,
        stack: o.stack
      } : o) : t.push(String(o));
    } catch (e) {
      t.push("[console log value cannot be serialized]");
    }
  }
  return t;
}
var L,
  P = [];
try {
  P = b("scrubbingKey") || [];
} catch (e) {
  g("Error in obtaining scrubbing keys"), P = C.scrubbingKey;
}
function A(e, n, t) {
  t++;
  try {
    "object" == typeof e && t <= 2 && Object.keys(e).forEach(function (r) {
      P.includes(r.toLowerCase()) && (e[r] = "xxx"), n.push(r);
      var o = e[r];
      "object" == typeof o && A(o, n, t);
    });
  } catch (e) {
    g("error while hiding the sensitive information: " + e);
  }
  return JSON.stringify(e);
}
function M(e, n, t, r) {
  var o = r ? e.request : e.response,
    i = b(r ? "xhrReqPayloadCapture" : "xhrRespPayloadCapture"),
    s = function s(n) {
      try {
        r ? (e.request = n, "" != e.request && (e.requestByteSize = t)) : (e.response = n, "" != e.response && (e.responseByteSize = t));
      } catch (e) {
        g("error while converting xhr data to string" + e);
      }
    };
  if (i) {
    var a = b("responseCapSize") || 1e6,
      u = b("requestCapSize") || 1e6,
      c = r ? u : a,
      d = b("sizeExceededMessage");
    "string" == typeof o && o.length > 0 ? (t = t || o.length) <= c ? function () {
      try {
        s(A(JSON.parse(o), [], n));
      } catch (n) {
        var e = P.some(function (e) {
          return o.indexOf(e) >= 0;
        });
        s(o = r ? e ? "No request payload captured for this request as you may have some sensitive information in the payload." : o : e ? "No response captured for this request as you may have some sensitive information in the payload." : o);
      }
    }() : t > 0 && s(JSON.stringify(d)) : "object" == typeof o ? (t = t || JSON.stringify(o, null, 4).length) <= c ? s(A(o, [], n)) : t > 0 && s(d) : o && o.length > 0 && ((t = t || o.length) <= c ? s(A(o, [], n)) : t > 0 && s(JSON.stringify(d)));
  } else r ? e.request = "" : e.response = "";
  return e;
}
function F(e) {
  if (!e) return !1;
  var n = e.toLowerCase(),
    t = b("ignoreError") || [];
  try {
    if (t.some(function (e) {
      return n.includes(e.toLowerCase());
    })) return p("Ignoring error for data: " + e), !0;
  } catch (e) {
    g("Error in ignore errors. Error - " + e.message);
  }
  return !1;
}
function G(e, n) {
  if (e && null != e) try {
    var t = "";
    t = "string" != typeof e ? JSON.stringify(e) : e;
    for (var r = o.RangeError; r <= o.EvalError; r++) if (-1 != t.search(o[r])) return r;
  } catch (e) {
    g(e);
  }
  return n;
}
function q(e, n) {
  try {
    var t = e();
  } catch (e) {
    return n(e);
  }
  return t && t.then ? t.then(void 0, n) : t;
}
function Z(e) {
  if ("online" != (navigator.onLine ? "online" : "offline")) {
    if (!window.iszInternetDisconnected) return window.iszInternetDisconnected = !0, p("handleConnectionChange :: send internet disconnected"), e(N({
      eventType: o.Offline,
      data: {
        status: "Offline",
        type: ""
      },
      isError: !1
    }));
  } else var n = setInterval(function () {
    fetch("//google.com", {
      mode: "no-cors"
    }).then(function () {
      return window.iszInternetDisconnected && (window.iszInternetDisconnected = !1, p("handleConnectionChange :: send internet connected"), e(N({
        eventType: o.Online,
        data: {
          status: "Online",
          type: ""
        },
        isError: !1
      }))), clearInterval(n);
    }).catch(function () {
      window.iszInternetDisconnected || (window.iszInternetDisconnected = !0, p("handleConnectionChange :: send internet disconnected"), e(N({
        eventType: o.Offline,
        data: {
          status: "Offline",
          type: ""
        },
        isError: !1
      })));
    });
  }, 5e3);
}
var J = new Map();
function j(e) {
  try {
    var n = window.localStorage.getItem(e);
    return !n && (l("fetched value from hashmap :" + (n = J.get(e))), n) ? (l("Going to update local storage:"), function () {
      try {
        l("inside localStorageUpdate function");
        for (var e, n = E(J.entries()); !(e = n()).done;) {
          var t = e.value;
          B(t[0], t[1]);
        }
      } catch (e) {
        g("inside updateLocalStorage catch block ${e.message}");
      }
    }(), n) : n;
  } catch (e) {
    return void g("inside zLocalStorageGetItem catch block ${e.message}");
  }
}
function B(e, n) {
  try {
    l("inside zLocalStorageSetItem for key :" + e + " and value :" + n), J.set(e, n), window.localStorage.setItem(e, n);
  } catch (e) {
    g("inside zLocalStorageSetItem catch block ${e.message}");
  }
}
function H(e) {
  try {
    l("inside zLocalStorageRemoveItem for key :" + e), J.delete(e), window.localStorage.removeItem(e);
  } catch (e) {
    g("inside zLocalStorageSetItem catch block ${e.message}");
  }
}
function W() {
  var e = j("zsdk-config");
  if (e) try {
    return JSON.parse(e);
  } catch (e) {
    return void g("Failed to parse sdk Config Data");
  }
}
function K(e) {
  var n = {
    isBlocked: !1,
    blockedEndTime: 0,
    apiKey: e
  };
  try {
    window.zSessionBlockedInfo = n, l("Updating zsession-blocked-info" + JSON.stringify(n)), B("zsession-blocked-info", JSON.stringify(n));
  } catch (e) {
    g("Failed to stringify zsession-blocked-info ");
  }
}
function V() {
  var e = j("zsession-blocked-info");
  if (e) try {
    var n = JSON.parse(e);
    return window.zSessionBlockedInfo = n, n;
  } catch (e) {
    return void g("Failed to parse zsession-blocked-info");
  }
}
function Y(e, n) {
  try {
    var t = e();
  } catch (e) {
    return n(e);
  }
  return t && t.then ? t.then(void 0, n) : t;
}
var X = function e(n, t, r, o, i) {
    void 0 === t && (t = 5), void 0 === i && (i = {});
    try {
      return Promise.resolve(Y(function () {
        var s = new URL(n);
        return null != r && Object.keys(r).forEach(function (e) {
          return s.searchParams.append(e, r[e]);
        }), Promise.resolve(fetch(s, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(o)
        })).then(function (s) {
          return s.ok ? (f("postDataOnServer :: Response status = " + s.status), Promise.resolve(s.json()).then(function (e) {
            return f("postDataOnServer :: Response JSON = " + e), e;
          })) : 404 == s.status ? (B("is-api-key-valid", "false"), ne(!1), !1) : (f("Error :: Response status = " + s.status), t > 0 ? e(n, t - 1, r, o, i) : (g("Not able to post enduser config after all retriues"), !1));
        });
      }, function (e) {
        return g("Not able to get response from server with ERROR: " + e), !1;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  $ = function e(n) {
    var t = n.divolteUrl,
      r = n.divolteJson,
      o = n.failureRetryCount;
    try {
      return Promise.resolve(Y(function () {
        return Promise.resolve(fetch(t, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Content-Encoding": "gzip"
          },
          body: JSON.stringify(r)
        })).then(function (n) {
          return n.ok ? (f("Response status = " + n.status), !0) : (f("Error :: Response status = " + n.status), o > 0 ? e({
            divolteUrl: t,
            divolteJson: r,
            failureRetryCount: o - 1
          }) : (g("Not able to send data after all retries"), !1));
        });
      }, function (e) {
        return g("Not able to get response from server with ERROR: " + e), !1;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  Q = !0;
function ee() {
  return Q;
}
function ne(e) {
  Q = e;
}
function te() {
  var e = j("session-data");
  if (e) try {
    return JSON.parse(e);
  } catch (e) {
    return void g("Failed to parse session data");
  }
}
function re(e) {
  if (window.iszSessionExpired) return p("Session is already expired"), !0;
  var n = (te() || {}).sessionId,
    t = Number(j("last-activity-time"));
  return !n || t + e.sessionTimeout <= Date.now() ? (l("Session is expired"), window.iszSessionExpired = !0, !0) : !function (e) {
    var n = oe();
    return !(!n || n + e.sessionTimeout <= Date.now());
  }(e);
}
function oe() {
  try {
    var e = window.zenduserLastActivityTime;
    if (!e) {
      if (!(e = j("zenduser-last-activity-time"))) return 0;
      e = Number(e);
    }
    return e;
  } catch (e) {
    return g("inside getZendUserActivityTime catch block"), 0;
  }
}
function ie() {
  var e = j("pack");
  if (!e) {
    var n = R();
    B("pack", e = n.pack ? n.pack.toString() : (!1).toString());
  }
  return "true" === e;
}
function se(e) {
  var n = j("zId");
  n || B("zId", n = I());
  var t = I(),
    r = "0:" + I().replace("-", ":");
  !function (e) {
    H("pack"), K(e);
  }(e), H("pack");
  var o = {
    sessionId: t,
    dSession: r,
    isNewSession: !0,
    sdkKey: e,
    isActive: !1
  };
  B("is-api-key-valid", "true"), ne(!0);
  try {
    l("Created new Session" + JSON.stringify(o)), B("session-data", JSON.stringify(o)), B("last-activity-time", Date.now().toString()), window.iszSessionExpired = !1;
  } catch (e) {
    g("Failed to stringify  session data");
  }
}
function ae(e) {
  var n = te();
  return !!n && e !== (null == n ? void 0 : n.sdkKey) && (l("Sdk key is chnaged going to create session data"), !0);
}
function ue() {
  var e = j("zId");
  return e || (B("zId", e = I()), e);
}
function ce() {
  var e = j("zenduser-info");
  if (e) try {
    return JSON.parse(e);
  } catch (e) {
    return void g("Failed to parse end user Info data");
  }
}
function de() {
  var e = j("zenduser-info-temp");
  if (e) try {
    return JSON.parse(e);
  } catch (e) {
    return void g("Failed to parse end user Info data");
  }
}
function le(e) {
  ue(), ce() || l("Creating new enduser-info" + JSON.stringify(e));
  try {
    l("Updating enduser-info" + JSON.stringify(e)), B("zenduser-info", JSON.stringify(e));
  } catch (e) {
    g("Failed to stringify  enduser-info ");
  }
}
function pe(e) {
  ue(), ce() || l("Creating new enduser-info-temp" + JSON.stringify(e));
  try {
    l("Updating enduser-info-temp" + JSON.stringify(e)), B("zenduser-info-temp", JSON.stringify(e));
  } catch (e) {
    g("Failed to stringify  enduser-info-temp ");
  }
}
function fe() {
  de() ? (l("Removing zenduser-info-temp"), H("zenduser-info-temp")) : l("zenduser temp Data dosen't exists");
}
function ge(e, n) {
  e.euId = 0, e.euZName = "", e.isBlocked = !1, e.zAnonymsUserInfo = {
    euId: 0,
    euZName: "",
    zId: null != n ? n : ""
  };
}
function ve(e, n) {
  var t,
    r,
    o = ue();
  (null == e || null == (t = e.zAnonymsUserInfo) ? void 0 : t.zId) === o ? (l("ZId match"), e.euId = e.zAnonymsUserInfo.euId, e.euZName = e.zAnonymsUserInfo.euZName) : (l("ZId dosen't match Zid : " + o + " and Anonyms user Zid: " + (null == e || null == (r = e.zAnonymsUserInfo) ? void 0 : r.zId)), ge(e, o)), n ? pe(e) : le(e);
}
function ye() {
  if (de()) return l("Temp storage has some pending data to post"), !0;
  var e = ce();
  if (!e) return l("zenduser Data dosen't exists"), !0;
  if (0 === e.euId) return l("Euid value is 0, required to fetch data again"), !0;
  if (e.userType === a.ANONYMS) {
    var n, t;
    if (null == e || null == (n = e.zExternalUserInfo) ? void 0 : n.externalId) return l("External User details exists, and userType is ANONYMS need to post data"), !0;
    var r = ue();
    if ((null == (t = e.zAnonymsUserInfo) ? void 0 : t.zId) !== r) return l("ZId dosen't match Zid : " + r + " and Anonyms user Zid: " + e.zAnonymsUserInfo.zId), ge(e, r), le(e), !0;
    l("ZId match No need to update for anonyms user");
  }
  return !1;
}
function we(e) {
  var n = {};
  return Object.keys(e).forEach(function (t) {
    "uniqueUserId" === t ? n.externalId = e[t] : n[t] = e[t];
  }), n;
}
var me = function me(e, n, t) {
    void 0 === n && (n = 0);
    try {
      var r = {
        v: c.sdkVersion,
        e: "Production",
        o: n,
        ns: t
      };
      if (n == s.POSTENDUSERINFOANDGETUSERCONFIG || n == s.GETUSERCONFIG) {
        var o = W();
        window.sdkConfig = o || C;
      }
      var i = V();
      if (i && i.isBlocked) return l("Not going to call post end user info as session is already blocked"), Promise.resolve(window.sdkConfig);
      window.iszHandshakeDone = !1, window.zpendingOp = n, p("config.sdkversion" + c.sdkVersion);
      var u = de() || {
          zAnonymsUserInfo: {}
        },
        d = {},
        f = a.ANONYMS;
      if (u) {
        var v,
          y = u.zExternalUserInfo || {};
        for (var w in y) d[k(w)] = y[w] ? y[w] : "";
        d.enduser_zipy_id = null == (v = u.zAnonymsUserInfo) ? void 0 : v.zId, y.externalId && (l("Get User info for user Type Identified " + y.externalId), f = a.IDENTIFIED);
      }
      return window.ztryForHandshake = !1, Promise.resolve(X(c.streamMgrUrl + "/" + e, c.streamMgrRetryCount, r, d)).then(function (t) {
        if (t) {
          if ((null == t ? void 0 : t.api_key) == e) {
            var r = V(),
              o = te() || {},
              i = !(null == t || !t.is_blocked) && (null == t ? void 0 : t.is_blocked);
            if (r && (r.isBlocked || o.isActive || ke(t, e)), i) return window.sdkConfig;
            if (n == s.POSTENDUSERINFOANDGETUSERCONFIG || n == s.GETUSERCONFIG) {
              var c = Ie(t);
              window.iszHandshakeDone = !0, l("sdkConfigResp" + JSON.stringify(c)), c && (window.sdkConfig = c);
            }
            if (n == s.POSTENDUSERINFOANDGETUSERCONFIG || n == s.POSTENDUSERINFO) {
              var d = t.enduser_info || {};
              l("Response object received for End User from stream manager: " + JSON.stringify(d)), d && (l("Going to add enduser info after data parsing"), u.userType = f, u.euId = d.id ? d.id : 0, u.euZName = d.zipy_eu_name ? d.zipy_eu_name : "", u.isBlocked = !!d.is_blocked && d.is_blocked, f == a.ANONYMS && (u.zAnonymsUserInfo.euId = u.euId, u.zAnonymsUserInfo.euZName = u.euZName, u.zExternalUserInfo = {}), le(u), fe());
            }
          } else g("Not able to get response from stream manager for sdk Key: " + e);
        } else g("Not able to get response from stream manager ");
        return window.sdkConfig;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
  he = function he(e) {
    try {
      var n,
        t = R(),
        r = window.zEventsData || [];
      p("Data Length for direct streaming ");
      var o = "";
      try {
        p("Data Length " + (o = JSON.stringify(r)).length);
      } catch (e) {
        g("Failed to stringify zEvents");
      }
      var i = null != t && t.eventCountCapInSingleChunk ? t.eventCountCapInSingleChunk : 0,
        s = i > 0 && r.length > i ? i : r.length;
      l("NIDHI :: Going to send data with chunk " + s + " total events count " + r.length + " chunk size " + i);
      var a = function () {
        if (2 * o.length >= t.bufferSizeFrequency || window.lastSyncTime + t.timeFrequency <= Date.now() && s > 0) {
          var i,
            a,
            u = r.slice(0, s),
            d = te() || {},
            p = ce() || {},
            f = j("zId"),
            v = null != (i = p.zExternalUserInfo) && i.externalId ? null == (a = p.zExternalUserInfo) ? void 0 : a.externalId : "",
            y = /\((.*)\)/.exec(new Date().toString())[1],
            w = ie(),
            m = {
              key: e,
              sdk_ver: c.sdkVersion,
              src: "Frontend",
              s_id: d.sessionId,
              euz_id: f,
              eue_id: v,
              events: u,
              eu_info_id: p.euId,
              rel_ver: window.zRelVer,
              handshake_status: window.iszHandshakeDone,
              ip: t.ip,
              deviceName: "",
              screenWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
              screenHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
              userAgent: window.navigator.userAgent,
              timeZone: y,
              pack: w
            },
            h = "";
          try {
            h = JSON.stringify(m);
          } catch (e) {
            g("Failed to stringify zipyDataJson");
          }
          var E = {
            eventData: h
          };
          return Promise.resolve(function (e) {
            try {
              ee() && "false" === j("is-api-key-valid") && ne(!1);
              var n = function () {
                if ("isActive" in (n = te() || {}) && !n.isActive && ee()) return l("Going to register new session"), Promise.resolve(function (e) {
                  try {
                    var n = {
                        v: c.sdkVersion
                      },
                      t = te(),
                      r = {
                        enduser_session_id: t.sessionId,
                        user_agent: window.navigator.userAgent,
                        ip_address: "",
                        location: "",
                        enduser_zipy_id: "",
                        project_release_version: "",
                        sdk_version: "",
                        device_name: "",
                        screen_width: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
                        screen_height: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
                      };
                    return Promise.resolve(X(c.registerSessionUrl + "/" + e, c.streamMgrRetryCount, n, r)).then(function (n) {
                      return n ? (function () {
                        var e = te();
                        if (!e) return !1;
                        try {
                          l("Setting session as active" + JSON.stringify(e)), e.isActive = !0, B("session-data", JSON.stringify(e));
                        } catch (e) {
                          return g("Failed to stringify  session data"), !1;
                        }
                      }(), ke(n, e), !0) : (g("Not able to register new session for session Id : " + t.sessionId), !1);
                    });
                  } catch (e) {
                    return Promise.reject(e);
                  }
                }(e)).then(function () {});
                var n;
              }();
              return Promise.resolve(n && n.then ? n.then(function () {}) : void 0);
            } catch (e) {
              return Promise.reject(e);
            }
          }(e)).then(function () {
            if (Ce()) return function () {
              for (; window.zEventsData.length;) window.zEventsData.pop();
              window.zEventsData = [];
            }(), n = !0;
            var e = {
                session_id: d.dSession,
                event_id: "AruZ~Em0WNlAnbyzVmwM~GR0cMb6Xl9r",
                is_new_party: d.isNewSession,
                is_new_session: d.isNewSession,
                client_timestamp_iso: new Date().toISOString(),
                event_type: "MyEventRecord",
                parameters: E
              },
              r = t.streamUrl + "?p=" + d.dSession;
            return window.isDataSyncInProgress = !0, ee() ? Promise.resolve($({
              divolteUrl: r,
              divolteJson: e,
              failureRetryCount: t.failureRetryCount
            })).then(function (e) {
              if (e) {
                if (window.lastSyncTime = Date.now(), function (e) {
                  window.zEventsData && Array.isArray(window.zEventsData) ? window.zEventsData.splice(0, e) : window.zEventsData = [];
                }(s), window.isDataSyncInProgress = !1, B("last-activity-time", window.zlastActivityTime), B("zenduser-last-activity-time", window.zenduserLastActivityTime), d.isNewSession) {
                  var t = te();
                  if (t) {
                    t.isNewSession = !1;
                    try {
                      B("session-data", JSON.stringify(t));
                    } catch (e) {
                      g("Failed to set session-data in localstorage");
                    }
                  }
                }
                return n = !0;
              }
            }) : (B("last-activity-time", window.zlastActivityTime), B("zenduser-last-activity-time", window.zenduserLastActivityTime), window.isDataSyncInProgress = !1, n = 1, !1);
          });
        }
      }();
      return Promise.resolve(a && a.then ? a.then(function (e) {
        return !n || e;
      }) : !n || a);
    } catch (e) {
      return Promise.reject(e);
    }
  };
function Ee(r, i) {
  p("Going to init rrweb Recorder"), window.zrrwebRecorderStatus = u.RECORDINGPENDING;
  var s,
    a = function a() {};
  try {
    a = e({
      emit: function emit(e) {
        var r = -1;
        e.type != n.IncrementalSnapshot ? r = o.ReplayerEvent : (r = e.data.source ? e.data.source : o.ReplayerEvent) >= o.MouseInteraction && r <= o.MediaInteraction && (window.zrrwebRecorderStatus = u.RECORDINGSUCCESSFUL, window.zenduserLastActivityTime = Date.now());
        try {
          var i = !1;
          window.reinitializationInProgress || (i = ie()), ze({
            data: i ? t(e) : JSON.stringify(e),
            time: e.timestamp,
            type: r,
            isError: !1,
            navigatedUrl: window.location.origin + window.location.pathname
          });
        } catch (e) {
          g("Failed to store rrweb recorder events");
        }
      },
      recordCanvas: b("canvasCapture"),
      blockClass: (s = b("blockClasses"), s && "string" == typeof s ? new RegExp(s) : s instanceof RegExp ? s : /zipy-block/),
      ignoreClass: "zipy-ignore",
      maskAllInputs: r,
      sampling: {
        mousemove: 150,
        scroll: 150,
        mouseInteraction: {
          MouseUp: !0,
          MouseDown: !0,
          Click: !0,
          ContextMenu: !1,
          DblClick: !0,
          Focus: !1,
          Blur: !1,
          TouchStart: !0,
          TouchEnd: !0
        }
      }
    });
  } catch (e) {
    g(e);
  }
  return a;
}
function Se(e) {
  return p("Going to init zipy Recorder"), function (e) {
    void 0 === e && (e = {});
    var n = e.emit;
    if (!n) return g("emit function is required to record data from zipy-event-recorder"), function () {};
    L = function L(e) {
      n(e);
    };
    try {
      var t = [];
      t.push(function (e) {
        var n = location.href,
          t = {
            navigatedUrl: window.location.href
          };
        e(N({
          eventType: o.NAVIGATION,
          data: t,
          isError: !1
        }));
        var r = window.history.pushState,
          i = window.history.replaceState;
        function s() {
          try {
            var t = {
              navigatedUrl: window.location.href
            };
            n != t.navigatedUrl && (e(N({
              eventType: o.NAVIGATION,
              data: t,
              isError: !1
            })), n = t.navigatedUrl);
          } catch (e) {
            g("not able to capture the navigation url");
          }
        }
        return window.history.pushState = function () {
          r.apply(window.history, arguments), window.dispatchEvent(new Event("pushstate")), window.dispatchEvent(new Event("locationchange"));
        }, window.history.replaceState = function () {
          i.apply(window.history, arguments), window.dispatchEvent(new Event("replacestate")), window.dispatchEvent(new Event("locationchange"));
        }, window.addEventListener("locationchange", s, !1), window.addEventListener("popstate", s), window.addEventListener("hashchange", s), function () {
          history.pushState = r, history.replaceState = i, window.removeEventListener("locationchange", s), window.removeEventListener("popstate", s), window.removeEventListener("hashchange", s);
        };
      }(L));
      var r = R();
      return l("In zipy-event-record " + JSON.stringify(r)), r.consoleCapture && t.push(function (e) {
        function n(e) {
          var n = "";
          if ("string" != typeof e) try {
            n = JSON.stringify(e);
          } catch (e) {} else n = e;
          try {
            if (-1 != n.search("zipy") || -1 != n.search("rrweb")) return !0;
          } catch (e) {
            return !0;
          }
          return !1;
        }
        function t(n, t) {
          try {
            var r;
            r = function (e) {
              if (!Array.isArray(e)) return "";
              for (var n, t = [], r = E(e); !(n = r()).done;) {
                var o = n.value;
                try {
                  t.push(o && "object" == typeof o ? "Error" === o.constructor.name ? String(o) : JSON.stringify(o) : String(o));
                } catch (e) {
                  t.push("[console log value cannot be serialized]");
                }
              }
              return t.join(" ");
            }(Array.from(t));
            var i = n == o.ConsoleError;
            if (function (e, n) {
              if (null == e) return !1;
              var t,
                r = e.toLowerCase(),
                o = R();
              try {
                t = n ? o.isIgnoreConsoleError : o.ignoreConsole;
              } catch (e) {
                g(e);
              }
              try {
                if (t.some(function (e) {
                  return r.includes(e.toLowerCase());
                })) return !0;
              } catch (e) {
                return !1;
              }
              return !1;
            }(r, i)) return;
            e(N({
              eventType: n,
              data: {
                arguments: r,
                argumentsObj: _(Array.from(t))
              },
              isError: i
            }));
          } catch (e) {
            return void g("Error in parsing console log. Error is: " + e.message);
          }
        }
        var r = console.error.bind(console);
        console.error = function () {
          n(arguments[0]) || t(o.ConsoleError, arguments), r.apply(console, arguments);
        };
        var i = console.log.bind(console);
        console.log = function () {
          n(arguments[0]) || t(o.ConsoleInfo, arguments), i.apply(console, arguments);
        };
        var s = console.warn.bind(console);
        console.warn = function () {
          n(arguments[0]) || t(o.ConsoleWarning, arguments), s.apply(console, arguments);
        };
        var a = console.debug.bind(console);
        return console.debug = function () {
          n(arguments[0]) || t(o.ConsoleDebug, arguments), a.apply(console, arguments);
        }, function () {
          console.error = r, console.log = i, console.warn = s, console.debug = a;
        };
      }(L)), r.stackTraceCapture && t.push(function (e) {
        var n = [z("error", function (n) {
          !function (e, n) {
            var t = e.message,
              r = e.filename,
              i = e.lineno,
              s = e.colno;
            if (F(t) || F(r)) p("Ignoring error from error callback " + t);else if (e.error) {
              var a, u, d;
              if (F(null == (a = e.error) ? void 0 : a.stack)) return void p("Ignoring error from error callback " + (null == (d = e.error) ? void 0 : d.stack));
              var l,
                f = null == (u = e.error) ? void 0 : u.stack;
              try {
                l = "string" != typeof f ? JSON.stringify(f) : f;
              } catch (e) {
                g("Failed to stringfy errorMsg inside error callback with exception" + e);
              }
              var v = {
                message: t,
                filename: r,
                lineno: i,
                colno: s,
                error: l
              };
              n(N({
                eventType: G(t, o.Error),
                data: v,
                isError: !0
              }));
            } else {
              if ((null == t || "" == t) && c.ignoreEmptyErros) return void p("Ignored empty error");
              var y = {
                message: t,
                filename: r,
                lineno: i,
                colno: s,
                error: ""
              };
              n(N({
                eventType: G(t, o.Error),
                data: y,
                isError: !0
              }));
            }
          }(n, e);
        }, window)];
        return n.push(z("unhandledrejection", function (n) {
          var t,
            r = "reason" in n ? null == n ? void 0 : n.reason : n,
            i = null != n && n.reason.stack ? n.reason.stack : n;
          try {
            t = "string" != typeof i ? JSON.stringify(i) : i;
          } catch (n) {
            g("Failed to stringfy errorMsg inside unhandledrejection callback with exception" + n);
          }
          var s = {
            message: "" + r,
            error: t,
            filename: "",
            colno: 0,
            lineno: 0
          };
          if (null != r && "" != r || "" != s.error && null != s.error || !c.ignoreEmptyErros) {
            var a = "";
            try {
              a = JSON.stringify(s.error);
            } catch (n) {
              g("Failed to stringfy exception");
            }
            F(s.message) || F(a) ? p("Ignoring error from unhandled " + r) : e(N({
              eventType: G(r, o.UnhandledRejection),
              data: s,
              isError: !0
            }));
          } else p("Ignoring empty errors");
        }, window)), function () {
          n.forEach(function (e) {
            return e();
          });
        };
      }(L)), r.networkCapture && (t.push(function (e) {
        function n(n, t) {
          b("networkCapture") && (window.stopRecording || function (e, n) {
            try {
              var t,
                r = b("isIgnoreUrlError"),
                o = b("ignoreUrl");
              t = n ? r : o;
              var i = e.indexOf("?");
              i > 0 && (e = e.substr(0, i));
              var s = e.toLowerCase();
              if (t.some(function (e) {
                return s.includes(e.toLowerCase());
              })) return !0;
            } catch (n) {
              g("Error in url decoding for url : " + e + " Error is - " + n);
            }
            return !1;
          }(t.requestUrl, t.status >= 400) || (t.requestUrl = function (e) {
            try {
              var n = new URL(e);
              if (e) {
                var t = new URLSearchParams(new URL(e).search);
                t.forEach(function (e, n) {
                  P.includes(n.toLowerCase()) && t.set(n, "xxx");
                }), n.search = t.toString();
              }
              return n.toString();
            } catch (n) {
              return g("updateQueryStringFromRequestUrl: ERROR WHILE HIDING QUERY PARAM VALUE: " + n), e;
            }
          }(t.requestUrl), t = M(t, 0, t.requestByteSize || 0, !0), t = M(t, 0, t.responseByteSize || 0, !1), e(N({
            eventType: n,
            data: t,
            isError: t.status >= 400
          }))));
        }
        function t(e, n) {
          if ("GET" == n || "get" == n) try {
            var t = e.split("/"),
              r = t[t.length - 1];
            if ("" == r && t.length >= 2 && (r = t[t.length - 2]), -1 != r.indexOf(".js") && !r.indexOf(".json") || -1 != r.indexOf(".map") || -1 != r.indexOf(".html") || -1 != r.indexOf(".css")) return l("Going to ignore response text for url " + e), !0;
          } catch (e) {
            return !1;
          }
          return !1;
        }
        if (null != window.zxhrInit || 1 == window.zxhrInit) return l("Network in already initialized"), function () {};
        var r = window.XMLHttpRequest.prototype.open;
        window.XMLHttpRequest.prototype.open = function () {
          var e = "";
          null != arguments[1] && null != arguments[1] && ("string" == typeof arguments[1] ? e = arguments[1] : arguments[1] instanceof URL && (e = arguments[1].href));
          var i,
            s,
            a = {
              request: "",
              requestMethod: arguments[0] ? arguments[0] : "",
              requestUrl: e,
              sourceLibrary: "xmlHttpClient",
              headers: {},
              response: "",
              responseHeaders: {},
              status: 400,
              requestStartTime: 0,
              duration: 0,
              requestByteSize: 0,
              responseByteSize: 0
            },
            u = this.send;
          this.send = function () {
            a.requestStartTime = Date.now(), a.request = arguments[0] ? arguments[0] : "", a = M(a, 0, 0, !0), u.apply(this, arguments);
          };
          var c = this.setRequestHeader;
          this.setRequestHeader = function () {
            2 !== arguments.length || T(arguments[0]) || (a.headers[arguments[0]] = arguments[1]), c.apply(this, arguments);
          }, this.addEventListener("load", function () {
            try {
              var r = function r() {
                  a.status = u.status, a.duration = i - a.requestStartTime, n(o.XHR, a);
                },
                u = this;
              i = Date.now();
              var c = function () {
                if (!t(e, a.requestMethod)) {
                  var n = q(function () {
                    function e() {
                      a.responseByteSize = t, a.response = s, a = M(a, 0, t, !1);
                    }
                    var n = u.getAllResponseHeaders().split("\n"),
                      t = 0;
                    n.forEach(function (e) {
                      if ("" !== e) {
                        var n = e.split(":");
                        a.responseHeaders[n[0]] = n[1].trim(), !t && n[0] && "content-length" == n[0].toLowerCase() && (t = n[1]);
                      }
                    });
                    var r = function () {
                      var e;
                      if ("blob" === (null == u ? void 0 : u.responseType)) return t = t || (null == u || null == (e = u.response) ? void 0 : e.size), Promise.resolve(new Response(null == u ? void 0 : u.response).text()).then(function (e) {
                        s = e;
                      });
                      s = null != u && u.responseText ? u.responseText : "", t = t || s.length;
                    }();
                    return r && r.then ? r.then(e) : e();
                  }, function () {
                    p("Error while capturing response text");
                  });
                  if (n && n.then) return n.then(function () {});
                }
              }();
              return Promise.resolve(c && c.then ? c.then(r) : r());
            } catch (e) {
              return Promise.reject(e);
            }
          }), this.addEventListener("error", function () {
            try {
              i = Date.now();
              var e = this.getAllResponseHeaders().split("\n"),
                t = 0;
              e.forEach(function (e) {
                if ("" !== e) {
                  var n = e.split(":");
                  a.responseHeaders[n[0]] = n[1].trim(), !t && n[0] && "content-length" == n[0].toLowerCase() && (t = n[1]);
                }
              });
              var r = b("responseCapSize") || 1e6,
                s = b("sizeExceededMessage");
              (t = t || (null == this ? void 0 : this.responseText.length)) && t <= r ? a.response = null != this && this.responseText ? this.responseText : "" : t > 0 && (a.response = s), a.responseByteSize = t || 0;
            } catch (e) {
              p("Error while capturing response text");
            }
            a.status = this.status ? this.status : 404, n(o.XHR, a);
          }), this.addEventListener("abort", function () {
            try {
              i = Date.now();
              var e = this.getAllResponseHeaders().split("\n"),
                t = 0;
              e.forEach(function (e) {
                if ("" !== e) {
                  var n = e.split(":");
                  a.responseHeaders[n[0]] = n[1].trim(), !t && n[0] && "content-length" == n[0].toLowerCase() && (t = n[1]);
                }
              }), s = null != this && this.responseText ? this.responseText : "", a.responseByteSize = t = t || s.length, a.response = s, a = M(a, 0, t, !1);
            } catch (e) {
              p("Error while capturing response text");
            }
            a.duration = i - a.requestStartTime, a.status = this.status ? this.status : 400, n(o.XHR, a);
          }), r.apply(this, arguments);
        };
        var i = window.fetch;
        return window.fetch = function () {
          var e,
            r = "",
            s = {
              sourceLibrary: "fetch",
              requestUrl: "",
              requestMethod: "",
              headers: "",
              request: "",
              response: "",
              responseHeaders: {},
              status: 400,
              requestStartTime: 0,
              duration: 0,
              requestByteSize: 0,
              responseByteSize: 0
            };
          s.requestStartTime = Date.now(), null != arguments[0] && null != arguments[0] && ("string" == typeof arguments[0] ? r = arguments[0] : arguments[0] instanceof URL && (r = arguments[0].href));
          try {
            if (null != arguments[1] && null != arguments[1]) {
              var a = arguments[1].body;
              a && (s.requestByteSize = JSON.stringify(a, null, 4).length);
            }
          } catch (e) {
            g("error while capturing data length");
          }
          try {
            arguments[1] && arguments[1].headers && (e = v({}, arguments[1].headers));
          } catch (e) {
            g("header is not present in the call");
          }
          s = M(s = {
            sourceLibrary: "fetch",
            requestUrl: r || "",
            requestMethod: arguments[1] && arguments[1].method ? arguments[1].method : "GET",
            headers: e ? x(e) : "",
            request: arguments[1] && arguments[1].body ? arguments[1].body : "",
            response: "",
            responseHeaders: {},
            status: 400,
            duration: 0,
            requestByteSize: 0,
            responseByteSize: 0,
            requestStartTime: s.requestStartTime
          }, 0, 0, !0);
          var u = i.apply(window, arguments);
          return new Promise(function (e, i) {
            var a = {
                status: 400
              },
              c = 0;
            u.then(function (n) {
              a = {
                status: n.status
              };
              for (var t, r = E(n.headers); !(t = r()).done;) {
                var o = t.value;
                o && (s.responseHeaders[o[0]] = o[1], !c && o[0] && "content-length" == o[0].toLowerCase() && (c = o[1]));
              }
              return e(n.clone()), n.json();
            }).then(function (e) {
              var i = Date.now(),
                u = b("xhrRespPayloadCapture");
              (!t(r, s.requestMethod) && a.status >= 400 || u) && (s.response = e, s = M(s, 0, c, !1)), s.duration = i - s.requestStartTime, s.status = a.status, n(o.XHR, s);
            }).catch(function (e) {
              var t = Date.now();
              s.status = a.status, s.duration = t - s.requestStartTime, n(o.XHR, s), i(e);
            });
          });
        }, window.zxhrInit = !0, function () {};
      }(L)), t.push(function (e) {
        var n = [z("online", function (n) {
          Z(e);
        }, window)];
        return n.push(z("offline", function (n) {
          Z(e);
        }, window)), function () {
          n.forEach(function (e) {
            return e();
          });
        };
      }(L))), t.push(function (e) {
        var n = [];
        return n.push(z("logEvent", function (n) {
          try {
            var t = null == n ? void 0 : n.detail,
              r = t.message,
              i = t.options,
              s = void 0 === i ? {} : i;
            p("Capturing log message for message : " + r + " options: " + JSON.stringify(s)), r && s && s.constructor === Object ? e(N({
              eventType: o.ZipyLogMessage,
              data: {
                message: r.length < 1024 ? r : r.substring(0, 1024),
                options: s
              },
              isError: !1
            })) : l("Didn't capture log message for message : " + r + " options: " + JSON.stringify(s));
          } catch (e) {
            g("Error in capturing log message. Error is - " + e.message);
          }
        }, window)), n.push(z("exceptionEvent", function (n) {
          try {
            var t,
              r = (null == (t = n.detail) ? void 0 : t.error) || {},
              i = r.message,
              s = r.name,
              a = void 0 === s ? "" : s,
              u = r.filename,
              c = void 0 === u ? "" : u,
              d = r.lineno,
              f = void 0 === d ? 0 : d,
              v = r.colno,
              y = void 0 === v ? 0 : v,
              w = r.cause,
              m = void 0 === w ? "" : w,
              h = r.stack,
              E = void 0 === h ? "" : h;
            if (m = m ? String(m) : "", p("Capturing exception message for message : " + i + " name: " + a + " stack: " + E), F(i) || F(a)) return void p("Ignoring exception logs for message: " + i);
            i ? e(N({
              eventType: o.ZipyLogException,
              data: {
                message: i,
                name: a,
                filename: c,
                lineno: f,
                colno: y,
                cause: m,
                stack: E
              },
              isError: !0
            })) : l("Didn't capture exception message for message : " + i + " name: " + a);
          } catch (e) {
            g("Error in capturing log message. Error is - " + e.message);
          }
        }, window)), n.push(z("errorEvent", function (n) {
          try {
            var t = null == n ? void 0 : n.detail,
              r = t.name,
              i = t.message,
              s = void 0 === i ? "" : i,
              a = t.category,
              u = void 0 === a ? "FE" : a,
              c = t.options,
              d = void 0 === c ? {} : c;
            if (p("Capturing exception message for message : " + s + " name: " + r), F(s) || F(r)) return void p("Ignoring error logs for message: " + s);
            s && r && d && d.constructor === Object ? e(N({
              eventType: "NE" === u ? o.ZipyLogNetworkError : o.ZipyLogFrontendError,
              data: {
                message: s.length < 1024 ? s : s.substring(0, 1024),
                name: r,
                category: u,
                options: d
              },
              isError: !0
            })) : l("Didn't capture error message for message : " + s + " name: " + r + " category:" + u + " options: " + JSON.stringify(d));
          } catch (e) {
            g("Error in capturing log message. Error is - " + e.message);
          }
        }, window)), function () {
          n.forEach(function (e) {
            return e();
          });
        };
      }(L)), r.webSocketsCapture && (f("Going to init websockets", window), window.sdkInit ? function () {
        if (f("Start recording"), window._websockets && window._websockets.length) for (var e = 0; e < window._websockets.length; e++) window._websockets[e] && window._websockets[e].zRecordStart && "function" == typeof window._websockets[e].zRecordStart && (window._websockets[e].zRecordStart(), f("Zipy Recording Status:"));
      }() : function (e) {
        function n(n, t) {
          window.stopRecording || e(N({
            eventType: n,
            data: t,
            isError: n == o.WSERROR
          }));
        }
        function t(e) {
          f("onmessage: ");
          var t = {
              data: e.data,
              type: e.type,
              wsTimestamp: e.timeStamp
            },
            r = {
              requestUrl: this.url ? this.url : "",
              responseData: {},
              status: "",
              protocols: this.protocol,
              extension: "string" == typeof this.extensions ? [this.extensions] : this.extensions,
              readyState: this.readyState,
              timestamp: Date.now(),
              wsMsgType: i.MESSAGERECEIVED
            };
          r.responseData = t, n(o.WSMESSAGE, r);
        }
        function r(e) {
          f("onclose: ");
          var t = window._websockets.indexOf(this.ws);
          t > -1 && window._websockets.splice(t, 1);
          var r = {
            requestUrl: this.url ? this.url : "",
            responseData: {},
            status: "",
            protocols: this.protocol,
            extension: "string" == typeof this.extensions ? [this.extensions] : this.extensions,
            readyState: this.readyState,
            timestamp: Date.now(),
            wsMsgType: i.SOCKETCLOSE
          };
          r.responseData = {
            code: e.code,
            reason: e.reason,
            type: e.type,
            wsTimestamp: e.timeStamp
          }, n(o.WSCLOSE, r);
        }
        function s(e) {
          f("onopen: ");
          var t = {
            requestUrl: this.url ? this.url : "",
            responseData: {},
            status: "",
            protocols: this.protocol,
            extension: "string" == typeof this.extensions ? [this.extensions] : this.extensions,
            readyState: this.readyState,
            timestamp: Date.now(),
            wsMsgType: i.SOCKETERROR
          };
          n(o.WSOPEN, t);
        }
        function a(e) {
          f("onerror: ");
          var t = {
            requestUrl: this.url ? this.url : "",
            responseData: {},
            status: "",
            protocols: this.protocol,
            extension: "string" == typeof this.extensions ? [this.extensions] : this.extensions,
            readyState: this.readyState,
            timestamp: Date.now(),
            wsMsgType: i.SOCKETERROR
          };
          t.responseData = {
            code: e.code,
            reason: e.reason,
            type: e.type,
            wsTimestamp: e.timeStamp
          }, n(o.WSERROR, t);
        }
        f("Inside captureWebSocketRequest"), f("Going to call WebSocket connection");
        var u = new Proxy(window.WebSocket, {
          construct: function construct(e, u) {
            f("WebSocket connection");
            var c = m(e, u),
              d = t,
              l = r,
              p = s,
              g = a,
              v = c.send;
            return c.zRecordStatus = "initiated", c.zRecordStart = function () {
              "started" !== c.zRecordStatus && (function (e) {
                var t = e.send;
                e.send = function (e) {
                  f("onsend");
                  var r = {
                    requestUrl: this.url ? this.url : "",
                    status: "",
                    protocols: this.protocol,
                    extension: "string" == typeof this.extensions ? [this.extensions] : this.extensions,
                    readyState: this.readyState,
                    requestData: arguments[0] ? arguments[0] : "",
                    timestamp: Date.now(),
                    wsMsgType: i.MESSAGESEND
                  };
                  t.apply(this, [e]), n(o.WSMESSAGE, r);
                };
              }(c), c.addEventListener("message", d), c.addEventListener("open", p), c.addEventListener("error", g), c.addEventListener("close", l), c.zRecordStatus = "started");
            }, c.zRecordStop = function () {
              "stopped" !== c.zRecordStatus && (c.send = v, c.removeEventListener("message", d), c.removeEventListener("open", p), c.removeEventListener("error", g), c.removeEventListener("close", l), c.zRecordStatus = "stopped");
            }, window._websockets = window._websockets || [], window._websockets.push(c), window.stopRecording || c.zRecordStart(), c;
          }
        });
        f("Going to set WebSocket connection"), window.WebSocket = u;
      }(L)), function () {
        t.forEach(function (e) {
          return e();
        }), function () {
          if (f("Stop recording"), window._websockets && window._websockets.length) for (var e = 0; e < window._websockets.length; e++) window._websockets[e] && window._websockets[e].zRecordStop && "function" == typeof window._websockets[e].zRecordStop && (window._websockets[e].zRecordStop(), f("Zipy Recording Status:"));
        }();
      };
    } catch (e) {
      return g(e), function () {};
    }
  }({
    emit: function emit(e) {
      try {
        if (e.eventType != o.Online || window.iszHandshakeDone || (window.ztryForHandshake = !0), window.iszSessionExpired) return void p("Don't store zipy events if session is expired");
        e.eventType >= o.Error && e.eventType <= o.UnhandledRejection && (window.zrrwebRecorderStatus = u.RECORDINGSUCCESSFUL), ze({
          data: JSON.stringify(e.data),
          time: e.timestamp,
          type: e.eventType,
          isError: e.isError,
          navigatedUrl: window.location.origin + window.location.pathname
        });
      } catch (e) {
        g("Failed to store events");
      }
    }
  });
}
function ze(e) {
  var n = R();
  window.zrecordingPaused || Ce() && !re(n) || ee() && window.zEventsData.push(e), window.zlastActivityTime = Date.now();
}
var Ie = function Ie(e) {
  var n,
    t = {
      domCapture: "boolean" == typeof (null == e ? void 0 : e.dom_capture) ? null == e ? void 0 : e.dom_capture : C.domCapture,
      consoleCapture: "boolean" == typeof (null == e ? void 0 : e.console_capture) ? null == e ? void 0 : e.console_capture : C.consoleCapture,
      networkCapture: "boolean" == typeof (null == e ? void 0 : e.network_capture) ? null == e ? void 0 : e.network_capture : C.networkCapture,
      stackTraceCapture: "boolean" == typeof (null == e ? void 0 : e.stack_trace_capture) ? null == e ? void 0 : e.stack_trace_capture : C.stackTraceCapture,
      webSocketsCapture: "boolean" == typeof (null == e ? void 0 : e.web_sockets_capture) ? null == e ? void 0 : e.web_sockets_capture : C.webSocketsCapture,
      ipCapture: "boolean" == typeof (null == e ? void 0 : e.ip_capture) ? null == e ? void 0 : e.ip_capture : C.ipCapture,
      inputMasking: "boolean" == typeof (null == e ? void 0 : e.input_masking) ? null == e ? void 0 : e.input_masking : C.inputMasking,
      textMasking: "boolean" == typeof (null == e ? void 0 : e.text_masking) ? null == e ? void 0 : e.text_masking : C.textMasking,
      paid: "boolean" == typeof (null == e ? void 0 : e.paid) ? null == e ? void 0 : e.paid : C.paid,
      apiKey: null == e ? void 0 : e.api_key,
      streamUrl: null != e && e.stream_url ? null == e ? void 0 : e.stream_url : C.streamUrl,
      maxBufferSize: null != e && e.max_buffer_size ? 1024 * (null == e ? void 0 : e.max_buffer_size) : C.maxBufferSize,
      compression: "boolean" == typeof (null == e ? void 0 : e.compression) ? null == e ? void 0 : e.compression : C.compression,
      compressionType: null != e && e.compression_type ? null == e ? void 0 : e.compression_type : C.compressionType,
      timeFrequency: null != e && e.time_frequency ? 1e3 * (null == e ? void 0 : e.time_frequency) : C.timeFrequency,
      encodingType: null == e ? void 0 : e.encoding_type,
      sessionTimeout: null != e && e.session_timeout ? 1e3 * (null == e ? void 0 : e.session_timeout) : C.sessionTimeout,
      failureRetryCount: null != e && e.failure_retry_count ? null == e ? void 0 : e.failure_retry_count : C.failureRetryCount,
      bufferSizeFrequency: null != e && e.buffer_size_frequency ? 1024 * (null == e ? void 0 : e.buffer_size_frequency) : C.bufferSizeFrequency,
      ignoreUrl: null != e && e.ignoreUrl ? null == e ? void 0 : e.ignoreUrl : C.ignoreUrl,
      ignoreError: null != e && e.ignoreError ? null == e ? void 0 : e.ignoreError : C.ignoreError,
      ignoreConsole: null != e && e.ignoreConsole ? null == e ? void 0 : e.ignoreConsole : C.ignoreConsole,
      isIgnoreUrlError: null != e && e.isIgnoreUrlError ? null == e ? void 0 : e.isIgnoreUrlError : C.isIgnoreUrlError,
      isIgnoreConsoleError: null != e && e.isIgnoreConsoleError ? null == e ? void 0 : e.isIgnoreConsoleError : C.isIgnoreConsoleError,
      ip: null != e && e.ip ? null == e ? void 0 : e.ip : "",
      pack: !(null == e || !e.pack || !e.pack),
      blockClasses: (n = null != e && e.blockClasses ? null == e ? void 0 : e.blockClasses : C.blockClasses, n = (n = n && n.length ? n + ",zipy-block" : "zipy-block").split(",").filter(O).map(D).join("|"), new RegExp(n)),
      customerId: null == e ? void 0 : e.cId,
      headersToSanitize: null != e && e.headersToSanitize ? e.headersToSanitize : "",
      xhrReqPayloadCapture: "boolean" == typeof (null == e ? void 0 : e.xhrReqPayloadCap) ? null == e ? void 0 : e.xhrReqPayloadCap : C.xhrReqPayloadCapture,
      xhrRespPayloadCapture: "boolean" == typeof (null == e ? void 0 : e.xhrRespPayloadCap) ? null == e ? void 0 : e.xhrRespPayloadCap : C.xhrRespPayloadCapture,
      canvasCapture: "boolean" == typeof (null == e ? void 0 : e.canvasCapture) ? null == e ? void 0 : e.canvasCapture : C.canvasCapture,
      requestCapSize: null != e && e.requestCapSize ? null == e ? void 0 : e.requestCapSize : C.requestCapSize,
      responseCapSize: null != e && e.responseCapSize ? null == e ? void 0 : e.responseCapSize : C.responseCapSize,
      sizeExceededMessage: null != e && e.sizeExceededMessage ? null == e ? void 0 : e.sizeExceededMessage : C.sizeExceededMessage,
      eventCountCapInSingleChunk: "number" == typeof (null == e ? void 0 : e.eventCountCapInSingleChunk) ? e.eventCountCapInSingleChunk : C.eventCountCapInSingleChunk,
      captureCustomZipyLogMessage: "boolean" == typeof (null == e ? void 0 : e.captureCustomZipyLogMessage) ? e.captureCustomZipyLogMessage : C.captureCustomZipyLogMessage,
      captureCustomZipyLogError: "boolean" == typeof (null == e ? void 0 : e.captureCustomZipyLogError) ? e.captureCustomZipyLogError : C.captureCustomZipyLogError,
      captureCustomZipyLogException: "boolean" == typeof (null == e ? void 0 : e.captureCustomZipyLogException) ? e.captureCustomZipyLogException : C.captureCustomZipyLogException
    };
  return t.ignoreUrl.push(t.streamUrl.substring(t.streamUrl.indexOf("://") + 3)), t.ignoreUrl.push(c.streamMgrUrl.substring(c.streamMgrUrl.indexOf("://") + 3)), t.ignoreUrl.push("google.com"), t.isIgnoreUrlError.push(t.streamUrl.substring(t.streamUrl.indexOf("://") + 3)), t.isIgnoreUrlError.push(c.streamMgrUrl.substring(c.streamMgrUrl.indexOf("://") + 3)), t.isIgnoreUrlError.push("google.com"), function (e) {
    if (e) try {
      var n;
      l("Updating zsdk-config" + JSON.stringify(e)), e.blockClasses = null == (n = e.blockClasses) ? void 0 : n.source, B("zsdk-config", JSON.stringify(e));
    } catch (e) {
      g("Failed to stringify zsdk-config ");
    }
  }(t), t;
};
function ke(e, n) {
  var t,
    r = (null == e ? void 0 : e.blocked_till) > 0 ? null == e ? void 0 : e.blocked_till : 0,
    o = r > 0 ? S() + r : 0;
  t = {
    isBlocked: !(null == e || !e.is_blocked) && (null == e ? void 0 : e.is_blocked),
    apiKey: n,
    blockedEndTime: o
  }, window.zSessionBlockedInfo = t, function (e) {
    if (e) try {
      l("Updating zsession-blocked-info" + JSON.stringify(e)), B("zsession-blocked-info", JSON.stringify(e));
    } catch (e) {
      g("Failed to stringify zsession-blocked-info ");
    }
  }(t);
}
function Ce() {
  var e = window.zSessionBlockedInfo || {};
  return !(null == e || !e.isBlocked) && e.isBlocked;
}
var Ne = function Ne(e) {
    try {
      var n,
        t = function t(_t) {
          if (n) return _t;
          function o() {
            function n(n) {
              function t() {
                Te(c.sdkLoopTime, e);
              }
              var o = function () {
                if (n) {
                  var t = function t() {
                      p("Successfully send data to server via session storage");
                    },
                    o = function () {
                      if (window.zrecordingPaused) {
                        window.zrecordingPaused = !1, window.reinitializationInProgress = !0;
                        var n = s.GETUSERCONFIG;
                        return ye() && (n = s.POSTENDUSERINFOANDGETUSERCONFIG), Promise.resolve(me(e, n, !1)).then(function (e) {
                          r = e, window.zStop = xe();
                        });
                      }
                    }();
                  return o && o.then ? o.then(t) : t();
                }
                var i = window.zEventsData || [],
                  a = "";
                try {
                  a = JSON.stringify(i);
                } catch (e) {
                  g("Failed stringify events while stream data server");
                }
                0 != r.maxBufferSize && 2 * a.length > r.maxBufferSize && !window.zrecordingPaused && (window.zrecordingPaused = !0, l("Max Buffer size is reached going to pause recording"));
              }();
              return o && o.then ? o.then(t) : t();
            }
            var t = !window.iszInternetDisconnected && window.zrrwebRecorderStatus != u.RECORDINGPENDING;
            return t ? Promise.resolve(he(e)).then(n) : n(t);
          }
          var i = function () {
            if (window.ztryForHandshake) return Promise.resolve(me(e, window.zpendingOp, !1)).then(function (e) {
              r = e;
            });
          }();
          return i && i.then ? i.then(o) : o();
        };
      if (0 == window.sdkInit) return l("Sdk is not initialized yet"), Te(c.sdkLoopTime, e), Promise.resolve();
      if (window.isDataSyncInProgress) return p("Data sync in in progress"), Te(c.sdkLoopTime, e), Promise.resolve();
      if (window.reinitializationInProgress) return p("Reinit is in progress"), Te(c.sdkLoopTime, e), Promise.resolve();
      var r = R(),
        o = function () {
          if (re(r) && window.zEventsData && window.zEventsData.length > 0 && !window.iszInternetDisconnected && window.zrrwebRecorderStatus != u.RECORDINGPENDING) {
            l("Session is expired Going to recreate session"), window.reinitializationInProgress = !0, se(e);
            var t = s.GETUSERCONFIG;
            return ye() && (t = s.POSTENDUSERINFOANDGETUSERCONFIG), Promise.resolve(me(e, t, !0)).then(function (t) {
              r = t, window.zrecordingPaused = !1, window.zStop = xe(), Te(c.sdkLoopTime, e), n = 1;
            });
          }
        }();
      return Promise.resolve(o && o.then ? o.then(t) : t(o));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  Re = 5,
  be = function be(e, n) {
    void 0 === n && (n = {
      releaseVer: ""
    });
    try {
      return Promise.resolve(function (t, r) {
        try {
          var o = function () {
            if (d = c.debugLogs, function () {
              try {
                return window.self !== window.top;
              } catch (e) {
                return !0;
              }
            }() && function () {
              try {
                return window.top.window.zipy ? (p("Zipy is present in parent"), !0) : (p("Zipy is not present in parent"), !1);
              } catch (e) {
                return !1;
              }
            }()) p("Not initalizing sdk as function is called inside iframe");else {
              var t = new RegExp(/^[a-zA-Z0-9]{8}$/);
              if (e && t.test(e)) return window.zRelVer = n.releaseVer, function () {
                try {
                  for (var e = Object.keys(localStorage), n = 0; n < e.length; n++) ["zsession-blocked-info", "session-data", "zId", "zenduser-info-temp", "zenduser-info", "last-activity-time", "pack", "zsdk-config", "is-api-key-valid", "zenduser-last-activity-time"].includes(e[n]) && (J.set(e[n], localStorage.getItem(e[n])), l("updated value in map is :" + J.get(e[n])));
                } catch (e) {
                  g("inside zLocalStorgeMapUpdate catch block ${e.message}");
                }
              }(), Promise.resolve(function (e, n) {
                var t = [];
                try {
                  for (window.sdkInit = !1, window.isDataSyncInProgress = !1, window.zEventsData = [], window.iszInternetDisconnected = !1, window.zlastActivityTime = Date.now(), window.zenduserLastActivityTime = oe(), window.zenduserLastActivityTime || (window.zenduserLastActivityTime = Date.now()), window.zrecordingPaused = !1, window.ztryForHandshake = !1, window.iszSessionExpired = !1, window.zrrwebRecorderStatus = u.NORECORDING; window.zEventsData.length;) window.zEventsData.pop();
                  var r = window.sessionStorage.getItem("pending-zEvents");
                  if (l("pendingEvents value is" + r), r) try {
                    var o;
                    o = JSON.parse(r), window.zEventsData = o;
                  } catch (e) {
                    g("Failed to parse zipyEvents");
                  }
                  var i = V();
                  i && i.apiKey == e || K(e), p("Zipy Recorder init"), ae(e) && (ce() ? (l("Removing enduser-info"), H("zenduser-info")) : l("zenduser Data dosen't exists"), fe());
                  var c = s.GETUSERCONFIG;
                  if (!ce() && !de()) {
                    c = s.POSTENDUSERINFOANDGETUSERCONFIG;
                    var d = ue(),
                      v = {
                        euId: 0,
                        euZName: "",
                        userType: a.ANONYMS,
                        isBlocked: !1,
                        zExternalUserInfo: n && n.uniqueUserId ? we(n) : {},
                        zAnonymsUserInfo: {
                          zId: d,
                          euId: 0,
                          euZName: ""
                        }
                      };
                    pe(v), le(v);
                  }
                  ye() && (c = s.POSTENDUSERINFOANDGETUSERCONFIG);
                  var y = !1;
                  (re(W() || {}) || ae(e)) && (se(e), y = !0), me(e, c, y).then(function (e) {
                    if (window.lastSyncTime = 0, e.domCapture) {
                      var n = Ee(e.inputMasking);
                      t.push(n);
                    }
                    t.push(Se()), window.zStop = function () {
                      window.stopRecording = !0, t.forEach(function (e) {
                        return e();
                      }), f("Calling zipy Stop Recorder");
                    }, window.sdkInit = !0;
                  }).catch(function (e) {
                    window.sdkInit = !0, g("Failed to get get sdk config from server: ");
                  });
                } catch (e) {
                  g(e);
                }
                return function () {};
              }(e, n.identifyDetails)).then(function () {
                Te(c.sdkLoopTime, e), function (e) {
                  document.addEventListener("visibilitychange", function (n) {
                    if ("visible" === document.visibilityState) re(e) || (window.reinitializationInProgress = !0, window.zStop = xe(), l("reinitializing the session on tabActive event"));else {
                      for (; window.zEventsData.length;) window.zEventsData.pop();
                      var t = window.zStop;
                      t && t();
                    }
                  });
                }(e);
              });
              g("Not able to process as sdk api key null or invalid.");
            }
          }();
        } catch (e) {
          return r(e);
        }
        return o && o.then ? o.then(void 0, r) : o;
      }(0, function (e) {
        g("Not able to init SDK: " + e.message);
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  Oe = function Oe(e, n) {
    void 0 === n && (n = {});
    try {
      if (!window.sdkInit) return g("Identify: SDK not initialized"), void setTimeout(function () {
        l("Calling identify again after 10 seconds"), function (e, n, t) {
          void 0 === n && (n = {}), (Re -= 1) > 0 ? Oe(e, n) : g("Identify session retries count exceeded");
        }(e, n);
      }, 1e4);
      if (!e || "string" != typeof e || e.length <= 0 || e.trim().length <= 0) return void g("Got wrong external UUID, Please validate: " + e);
      l("identify :: externalUUId - " + e);
      var t = ce(),
        r = te() || {},
        o = s.POSTENDUSERINFO,
        i = n;
      i.externalId = e;
      var u = !1;
      if (t) {
        var c;
        t.userType == a.ANONYMS || (f = null == (c = t) ? void 0 : c.zExternalUserInfo, v = i, l("NewEndUserInfo :: " + JSON.stringify(v)), l("PrevEndUserInfo :: " + JSON.stringify(f)), (null == f ? void 0 : f.externalId) === (null == v ? void 0 : v.externalId) ? o = s.POSTENDUSERINFOANDGETUSERCONFIG : (t.euId = 0, t.euZName = "", t.userType = a.ANONYMS, t.isBlocked = !1, u = !0, o = s.POSTENDUSERINFOANDGETUSERCONFIG, se(r.sdkKey), window.reinitializationInProgress = !0));
      } else {
        var d = ue();
        t = {
          euId: 0,
          euZName: "",
          userType: a.ANONYMS,
          isBlocked: !1,
          zExternalUserInfo: {},
          zAnonymsUserInfo: {
            zId: d,
            euId: 0,
            euZName: ""
          }
        };
      }
      window.iszHandshakeDone || (o = s.POSTENDUSERINFOANDGETUSERCONFIG), t.zExternalUserInfo = i, pe(t);
      var p = V();
      p && r ? !u && p.isBlocked ? l("No need to do backend call if session is blocked") : me(r.sdkKey, o, u).then(function (e) {
        u && (window.zStop = xe());
      }).catch(function (e) {
        g("Failed to post/get sdk config from server: ");
      }) : g("Value doesn't exists in sessionBlockInfo or sessionData : ");
    } catch (e) {
      g("Not able to identify SDK: " + e.message);
    }
    var f, v;
  },
  De = function De() {
    if (window.sdkInit) {
      l("Going to anonymize end user");
      var e,
        n = !1;
      (((e = ce()) ? e.userType === a.IDENTIFIED : (l("zenduser-info doesn't exists"), 0)) || function () {
        var e = de();
        return e ? e.userType === a.IDENTIFIED : (l("zenduser-info doesn't exists"), !1);
      }()) && (n = !0);
      var t = function () {
          var e = ce();
          return e ? (e.zExternalUserInfo = {}, e.userType = a.ANONYMS, ve(e, !1), e) : (l("zenduser Data dosen't exists"), function () {
            var e = de();
            if (e) return e.zExternalUserInfo = {}, e.userType = a.ANONYMS, ve(e, !0), e;
            l("zenduser Data dosen't exists in temp storage");
          }());
        }() || {},
        r = s.GETUSERCONFIG;
      0 === t.euId ? (r = s.POSTENDUSERINFOANDGETUSERCONFIG, pe(t), le(t)) : (le(t), fe());
      var o = te();
      o && n ? (window.reinitializationInProgress = !0, se(null == o ? void 0 : o.sdkKey), me(null == o ? void 0 : o.sdkKey, r, !0).then(function (e) {
        window.zStop = xe();
      }).catch(function (e) {
        g("Failed to post/get sdk config from server: ");
      })) : l("Identified user doesn't exists in system No need to break session");
    } else g("Anonymize: SDK not initialized");
  };
function xe(e) {
  var n = [];
  try {
    if (p("Zipy Recorder Reinit"), window.isDataSyncInProgress = !1, !window.stopRecording) {
      l("Going to stop recording ");
      var t = window.zStop;
      t && t();
    }
    for (window.iszInternetDisconnected = !1; window.zEventsData.length;) window.zEventsData.pop();
    window.zEventsData = [], window.stopRecording = !1;
    var r = R();
    if (r.domCapture) {
      var o = Ee(r.inputMasking);
      n.push(o);
    }
    return n.push(Se()), window.reinitializationInProgress = !1, function () {
      window.stopRecording = !0, f("Calling zipy Stop Recorder"), n.forEach(function (e) {
        return e();
      });
    };
  } catch (e) {
    g(e);
  }
  return function () {};
}
function Te(e, n) {
  setTimeout(Ne, e, n);
}
var Ue = function Ue() {
    try {
      var e = R(),
        n = j("zsession-blocked-info"),
        t = JSON.parse(n);
      if (!window.sdkInit || t.is_blocked) return g("SessionLink: SDK not initialized"), "";
      var r = te() || {},
        o = j("zId");
      return e.customerId ? c.sessionLinkUrl + "/" + r.sdkKey + "/" + e.customerId + "?is_error=false&id=" + o + "&euid=" + r.sessionId : (g("SessionLink: Could not find customer id"), "");
    } catch (e) {
      return g("Error in generating session url. Error is - " + e.message), "";
    }
  },
  _e = function _e(e, n) {
    try {
      var t = R();
      if (!t || t && !t.captureCustomZipyLogMessage) return void l("Custom Zipy Message not enabled.");
      if (e && "string" == typeof e) {
        var r = new CustomEvent("logEvent", {
          detail: {
            message: e,
            options: n
          }
        });
        window.dispatchEvent(r);
      } else p("Mandatory params missing for zipy logs");
    } catch (e) {
      p("Error in capturing zipy logs. Error - " + e.message);
    }
  },
  Le = function Le(e) {
    try {
      var n = R();
      if (!n || n && !n.captureCustomZipyLogMessage) return void l("Custom Zipy Exception not enabled.");
      if (e) {
        var t = new CustomEvent("exceptionEvent", {
          detail: {
            error: e instanceof Error ? e : {
              message: String(e)
            }
          }
        });
        window.dispatchEvent(t);
      } else p("Mandatory params missing for zipy exception missing");
    } catch (e) {
      p("Error in capturing zipy exception event. Error - " + e.message);
    }
  },
  Pe = function Pe(e, n, t, r) {
    try {
      var o = R();
      if (!o || o && !o.captureCustomZipyLogError) return void l("Custom Zipy Error not enabled.");
      if (e && n && "string" == typeof e && "string" == typeof n) {
        var i = new CustomEvent("errorEvent", {
          detail: {
            name: e,
            message: n,
            category: t,
            options: r
          }
        });
        window.dispatchEvent(i);
      } else p("Mandatory params missing for zipy error logs");
    } catch (e) {
      g("Error in capturing zipy error event. Error - " + e.message);
    }
  },
  Ae = {
    init: be,
    identify: Oe,
    anonymize: De,
    getCurrentSessionURL: Ue,
    logError: Pe,
    logException: Le,
    logMessage: _e
  };
export { De as anonymize, Ae as default, Ue as getCurrentSessionURL, Oe as identify, be as init, Pe as logError, Le as logException, _e as logMessage };